var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 8,
    height: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.20312L8.75 0.328125C7.96875 -0.109375 7.03125 -0.109375 6.25 0.328125L1.25 3.20312C0.46875 3.64062 0 4.48437 0 5.35937V11.1406C0 12.0469 0.46875 12.8594 1.25 13.2969L6.25 16.1719C7.03125 16.6094 7.96875 16.6094 8.75 16.1719L13.75 13.2969C14.5312 12.8594 15 12.0156 15 11.1406V5.39062C15 4.48437 14.5312 3.67187 13.75 3.20312ZM9.8125 11.8281L7.5 10.5781L5.1875 11.7969L5.625 9.20312L3.75 7.35937L6.34375 6.98437L7.5 4.64062L8.65625 7.01562L11.25 7.39062L9.375 9.23437L9.8125 11.8281Z",
    fill: "#7069FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBadge);
export default __webpack_public_path__ + "static/media/adminBadge.a526db9dc70c30ac51d364c4605042a3.svg";
export { ForwardRef as ReactComponent };